/**
 * Port export configuration
 */

import type { ExportColumnConfig } from '@/components/export/universal/types';

export const PORT_COLUMNS: readonly ExportColumnConfig[] = [
  { id: 'protocol', label: 'Protocol', defaultSelected: true },
  { id: 'port', label: 'Port', defaultSelected: true },
  { id: 'service', label: 'Service', defaultSelected: true },
  { id: 'status', label: 'Status', defaultSelected: true },
  { id: 'source', label: 'Asset Key' },
  { id: 'capability', label: 'Detected By' },
  { id: 'tags', label: 'Tags' },
  { id: 'first_seen', label: 'First Seen', defaultSelected: true },
  { id: 'last_seen', label: 'Last Seen', defaultSelected: true },
];
